import { atom } from 'recoil';

import { FilterModalTypes } from '../../components/FilterModal';

import { subscriptionAvailableFilters } from './constants';

export const subscriptionsFiltersAtom = atom<FilterModalTypes.FilterAtom>({
  key: 'subscriptionsFiltersAtom/filterSelections',
  default: {
    availableFilters: subscriptionAvailableFilters,
    selectedFilters: [],
    appliedFilters: [],
  },
});
